import axios from 'axios';
import { getEndpoint, getRequestHeaders  } from './config'

export default function (destinationId: any, name: string) {
    return new Promise<any>((resolve, reject) => {
        axios
            .post(
                getEndpoint('destinations/{id}/users', { id: destinationId }),
                {
                    email: name
                },
                getRequestHeaders(true)
            )
            .then(function (response : any) {
                resolve(response.data);
            })
            .catch(function (rs : any) {
                reject(rs);
            });
    });
}